/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import PanelCurso from './PanelCurso';
import * as validations from '../../validations/validations';
import * as cursoActions from '../../actions/cursoActions';
import * as contenidoActions from '../../actions/contenidoActions';
import * as tagActions from '../../actions/tagActions';
import * as moduloActions from '../../actions/moduloActions';
import * as usuarioActions from '../../actions/usuarioActions';
import {  useParams } from "react-router-dom";
//import {  useLocation, useNavigate  } from "react-router-dom";
import withRouter from '../common/withRouter';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import { Segment} from 'semantic-ui-react';
import {genericFormattedForDropdown} from '../../selectors/selectors';
import moment from 'moment';
import {getMargenes} from '../../util/';
import $ from 'jquery';
import dayjs from 'dayjs';


import {usuarioActual} from '../../util';
import * as userActions from '../../actions/userActions';
import * as paginaActions from '../../actions/paginaActions';
import * as menuActions from '../../actions/menuActions';



class ManageCursoForm extends React.Component {

    constructor(props, context){
		super(props, context);
		this.state={
            
            headersTablaModulos:["Editar","Orden", "Modulo","Gratuito", "Fecha"],
            camposTablaModulos:[ "idModulo", "orden" , "idModulo", "gratuito", "fecha"],
            validacionesTablaModulos:[
                        {"name":"orden", "type":"int","max":100,"min":0}
            ],
            tipoTablaModulos:["button", "input","combo", "Checkbox",  "date"],
            errors:{},
            permisos:{},
			curso:{
                fechaInicio: new moment().format('DD/MM/YYYY'),
                idsTags:[],
                idsCursosPreviosOpcinales:[],
                idsCursosPreviosObligatorios:[],
                idsCursosSimilares:[]
                },
            imgBanner:{
                imagePreviewUrl:null
            },
            imgThumb:{
                imagePreviewUrl:null
            },
            imgPresentacion:{
                imagePreviewUrl:null
            }
            
		};
		
	}
    
    
    componentDidMount(){
        usuarioActual(this, "Curso",true).then( (usuario)=>{
        
        let id=this.props.id;
            
        this.props.usuarioActions.getUsuarioCombo(14, usuario).then( ()=>{ 
           
       }) 
        .catch(error=>{ 
          toastr.error(error); 
        });
        
        
        this.props.moduloActions.getModuloCombo(usuario).then( ()=>{ 
           
       }) 
        .catch(error=>{ 
          toastr.error(error); 
        });
        
        this.props.cursoActions.getCursoCombo(usuario).then( ()=>{ 
           
       }) 
        .catch(error=>{ 
          toastr.error(error); 
        }); 
    
        this.props.cursoActions.getCursoTipoCombo(usuario).then( ()=>{ 
           
       }) 
        .catch(error=>{ 
          toastr.error(error); 
        });     
        
        
        this.props.tagActions.getTagCombo(usuario).then( ()=>{ 
           
       }) 
        .catch(error=>{ 
          toastr.error(error); 
        }); 
        
        
        this.props.showSidebarIzquierdaActions.sidebarIzquierda(true);
            if(id && id>0 ){
            
                this.props.cursoActions.getCurso(id, usuario).then( curso=>{
                    
                    let imgBanner = this.state.imgBanner;
                    let imgThumb = this.state.imgThumb;
                    let imgPresentacion = this.state.imgPresentacion;
            
                    if(curso.imagenBanner!=null){
                           imgBanner.imagePreviewUrl= curso.imagenBanner;
                        
                    }
                    if(curso.imagenThumbnails!=null){
                           imgThumb.imagePreviewUrl= curso.imagenThumbnails;
                        
                    }
                    if(curso.imagenBannerPresentacion!=null){
                           imgPresentacion.imagePreviewUrl= curso.imagenBannerPresentacion;
                        
                    }
   
                    if(curso.fechaInicio!=null){
                        curso.fechaInicio= new moment(curso.fechaInicio).format('DD/MM/YYYY');    
                    }else{
                        curso.fechaInicio= new moment().format('DD/MM/YYYY'); 
                    }
              
        
                    
                    this.setState({"curso":curso});
               })
                .catch(error=>{
                  toastr.error(error);
                }); 
            }
       })
        .catch(error=>{
          toastr.error(error);
        }); 
        
        

		
    }

    
    handleChangeCurrency=(value, name)=> {
        let data={
            'value':value,
            'name':name
        };
        this.handleChange({}, data);
    }
    
    handleChange=(event, data)=> {

        let curso = this.state.curso;
        let field= data.name;		
        let value= data.value;

    
        if(data.type == 'checkbox'){
            if(data.checked){
                value=1;
            }else{
                value=0;
            }    
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		curso[field[0]]= value;
		else{
             if(!curso[field[0]]){
                    curso[field[0]]={}
                }
			curso[field[0]][field[1]]= value;
		}
        
		
        this.setState({"curso": curso});
    }
    
    fechas=(fechasArreglo, fechasCadena)=>{
        let curso = this.state.curso;
        curso.fechadayJS = fechasArreglo;
        curso.fechaInicio = fechasCadena;
        this.setState({curso:curso});
    }
    
    onBuscar=(event)=>{
        event.preventDefault();
        let curso = this.state.curso;
        
        if(curso.prefijo!=""){
            this.props.contenidoActions.getArchivosDisponibles(29, this.props.user, curso.prefijo).then( archivos=>{
               this.setState({"archivos":archivos});
           })
            .catch(error=>{
              toastr.error(error);
            }); 
        }
        
    }
    
    
    FormIsValid(){
        let formIsValid=true;
        let falla="";
        let errors={};
            
        let curso=this.state.curso;
              
        if(!validations.requerido(curso.titulo)){
            errors.titulo=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(curso.descripcionCorta)){
            errors.descripcionCorta=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(curso.cantidadModulos)){
            errors.cantidadModulos=true;
            formIsValid=false;
        }
        
        if(!validations.requerido(curso.horasTotales)){
            errors.horasTotales=true;
            formIsValid=false;
        }
        
        if(!validations.requerido(curso.descripcionLarga)){
            errors.descripcionLarga=true;
            formIsValid=false;
        }
       /*
        if(!validations.requerido(curso.imagenBanner)){
            errors.imagenBanner=true;
            formIsValid=false;
        }
       */
        /*
        if(!validations.requerido(curso.imagenThumbnails)){
            errors.imagenThumbnails=true;
            formIsValid=false;
        }
        */
        this.setState({
            "errors":errors
        });
        
        if(!formIsValid){
			toastr.error("Debes capturar la información requerida.");
        }
    
        return formIsValid;
    }

  

    onSave=(event)=>{
        event.preventDefault();
        if(!this.FormIsValid()){
            return ;
        }
        
        let newState=Object.assign({}, this.state.curso);
    
        newState.fechaInicio = dayjs(this.state.curso.fechadayJS).format('YYYY/MM/DD hh:mm:ss');
        
      
        this.props.cursoActions.saveNuevo(newState, this.props.user).then(() => {
            toastr.success("Registro guardado!!!.");
            this.props.navigate(-1);
        })
        
    }

    HandleFileImagen=(event, data, tipo)=> {
        
        
        let tamano;
        let imagen;
        
        if(tipo===1)
            imagen = this.state.imgBanner;
        if(tipo===2)
            imagen = this.state.imgThumb;
        if(tipo===3)
            imagen = this.state.imgPresentacion;
        
        let field= data.name;		
        let value;
        
        let file = event.target.files[0];
        if (!file){
            
        
                imagen.fileReg = '';
                imagen.imagePreviewUrl='';
            
                if(tipo===1)
                    this.setState({"imgBanner": imagen});
                if(tipo===2)
                    this.setState({"imgThumb": imagen});
                if(tipo===3)
                    this.setState({"imgPresentacion": imagen});
            
            return;
        }


        if(event.target.files[0].size<=((1024*1024)*2)){
            
            imagen['fileReg'] = event.target.files[0];
            imagen['imagePreviewUrl'] = URL.createObjectURL(event.target.files[0]);
           
            if(tipo===1)
                this.setState({"imgBanner": imagen});
            if(tipo===2)
                this.setState({"imgThumb": imagen});
            if(tipo===3)
                this.setState({"imgPresentacion": imagen});
            
            return;
        }else{
            tamano= Number(event.target.files[0].size)/Number(1048576);
            imagen.fileReg = '';
            imagen.imagePreviewUrl='';
           
            if(tipo===1)
                this.setState({"imgBanner": imagen});
            if(tipo===2)
                this.setState({"imgThumb": imagen});
            if(tipo===3)
                this.setState({"imgPresentacion": imagen});

            toastr.error("El archivo que intenta anexar mide "+tamano.toFixed(2)+" Mb. No se permiten imagnees mayores a 2 Mb!!!");
            return;
        } 
         
     }
   
    
      onSaveImage=(event)=>{
            event.preventDefault();
            if(!this.FormIsValid()){
                return ;
            }
    
            var image = this.state.imgBanner.fileReg;
            if(image instanceof File){

                var form_data = new FormData();
                form_data.append('file', image);
                form_data.append('tipo', 'imgBanner');
                form_data.append('id', this.props.id);

                this.props.cursoActions.saveImagen(form_data, this.props.user).then((imagen) => {

                    toastr.success("Imagen guardada correctamente!!!.");

                }).catch(error=>{
                  toastr.error(error.responseJSON.message);
                });

            }
          
            var image = this.state.imgThumb.fileReg;
            if(image instanceof File){

                var form_data = new FormData();
                form_data.append('file', image);
                form_data.append('tipo', 'imgThumb');
                form_data.append('id', this.props.id);

                this.props.cursoActions.saveImagen(form_data, this.props.user).then((imagen) => {

                    toastr.success("Imagen guardada correctamente!!!.");

                }).catch(error=>{
                  toastr.error(error.responseJSON.message);
                });

            }
          
            var image = this.state.imgPresentacion.fileReg;
            if(image instanceof File){

                var form_data = new FormData();
                form_data.append('file', image);
                form_data.append('tipo', 'imgPresentacion');
                form_data.append('id', this.props.id);

                this.props.cursoActions.saveImagen(form_data, this.props.user).then((imagen) => {

                    toastr.success("Imagen guardada correctamente!!!.");

                }).catch(error=>{
                  toastr.error(error.responseJSON.message);
                });

            }
          
          

      }
       
    render() {	
          
   let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
        //console.log(this.props);
		 		return (
              <Segment  style={margenes}>
                <PanelCurso 
                    strings={this.props.strings}
                    id={this.props.id}
                    onChange={this.handleChange}
                    errors={this.state.errors}
                    datos={this.state.curso}
                    onSave={this.onSave}      
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    color={this.props.color}
                    form={this.props.form}
                    permisos={this.state.permisos}
                    archivos={genericFormattedForDropdown(this.state.archivos)}
                    onChangeCurrency={this.handleChangeCurrency}
                    cursoCombo={genericFormattedForDropdown(this.props.cursoCombo)}
                    cursoTipoCombo={genericFormattedForDropdown(this.props.cursoTipoCombo)}
                    tagCombo={genericFormattedForDropdown(this.props.tagCombo)}
                    headersTablaModulos={this.state.headersTablaModulos}
                    camposTablaModulos={this.state.camposTablaModulos}
                    validacionesTablaModulos={this.state.validacionesTablaModulos}
                    tipoTablaModulos={this.state.tipoTablaModulos}
                    usuarioCombo={genericFormattedForDropdown(this.props.usuarioCombo)}
                    moduloCombo={genericFormattedForDropdown(this.props.moduloCombo)}
                    fechas={this.fechas}
                    verModulo={this.verModulo}
                    onBuscar={this.onBuscar}
                    onHandleFileImagen={this.HandleFileImagen}
                    imgBanner={this.state.imgBanner}
                    imgThumb={this.state.imgThumb}
                    imgPresentacion={this.state.imgPresentacion}
                    onSaveImage={this.onSaveImage}    
                />

            </Segment> 
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
    //let id = ownProps.match.params.id;

    let parametros = Parametros();
    return {        
        ajaxCallInProgress:state.ajaxCallInProgress,
        
        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda, 
        color:state.color,
        user:state.user, 
        idioma:state.idioma,
        tagCombo:state.tagCombo,
        cursoCombo:state.cursoCombo,
        moduloCombo:state.moduloCombo,
        usuarioCombo:state.usuarioCombo,
        strings:state.strings,
        tablas:state.tablas,
        form:state.form,
        cursoTipoCombo:state.cursoTipoCombo
    }

}

function mapDispatchToProps(dispatch){

	return { 
        userActions:bindActionCreators(userActions, dispatch),
        menuActions:bindActionCreators(menuActions, dispatch),
        tagActions: bindActionCreators(tagActions, dispatch),
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
        paginaActions: bindActionCreators(paginaActions, dispatch),
        cursoActions: bindActionCreators(cursoActions, dispatch),
        moduloActions: bindActionCreators(moduloActions, dispatch),
        usuarioActions: bindActionCreators(usuarioActions, dispatch),
	    contenidoActions: bindActionCreators(contenidoActions, dispatch)
    };
}

function Parametros(){
    const {id} = useParams();
    return{
        id
    }
}



export default connect (mapStateToProps, mapDispatchToProps)(withRouter(ManageCursoForm));